import React from 'react';
interface SectionHeaderProps {
  id: string;
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  eyebrowTone?: 'terracota' | 'petroleo';
}
export function SectionHeader({
  id,
  eyebrow,
  title,
  description,
  eyebrowTone = 'terracota'
}: SectionHeaderProps) {
  const tones = {
    terracota: 'text-terracota',
    petroleo: 'text-petroleo'
  };
  return <div className="text-center" data-id="element-160" data-mp="2v6hmt0731p76">
      {eyebrow && <p className={`font-hand text-[1.7rem] leading-none sm:text-4xl ${tones[eyebrowTone]}`} data-id="element-161" data-mp="2v70vrrer9392">{eyebrow}</p>}
      <h2 id={id} className="mt-1 font-serif text-2xl font-bold leading-tight text-azul sm:text-4xl" data-id="element-162" data-mp="303hv7hren41g">
        {title}
      </h2>
      {description && <p className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-azul/80 sm:text-base" data-id="element-163" data-mp="2q6liezuh3vr3">{description}</p>}
    </div>;
}